// extracted by mini-css-extract-plugin
export default {"resultList":"ResultList_resultList__D9PWH","list__title":"ResultList_list__title__GGMUV"};